import { useEffect, useState } from "react";
import { api } from "../../api";
import { Card, PageHead, Btn } from "../../components/ui";
import Icon from "../../components/Icon";

function timeAgo(iso) {
  const d = new Date(iso); const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return d.toLocaleDateString();
}

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = () => api.myNotifications().then(setItems).catch(() => {});
  useEffect(() => { load(); }, []);
  const markAll = async () => { try { await api.readAllNotifications(); load(); } catch (e) {} };
  const unread = items.filter((n) => !n.is_read).length;

  return (
    <div>
      <PageHead title="Notifications" sub={unread ? `${unread} unread` : "You're all caught up."}
        right={items.length > 0 && <Btn variant="outline" onClick={markAll}>Mark all read</Btn>} />
      {items.length === 0 ? (
        <Card className="p-8 text-center text-slate-400"><Icon name="bell" size={22} className="mx-auto mb-2" />No notifications yet.</Card>
      ) : (
        <div className="space-y-2">
          {items.map((n) => (
            <Card key={n.id} className={`p-4 flex gap-3 ${n.is_read ? "" : "border-l-4"}`} style={n.is_read ? {} : { borderLeftColor: "#4F46E5" }}>
              <div className={`mt-0.5 ${n.is_read ? "text-slate-300" : "text-indigo-600"}`}><Icon name="bell" size={18} /></div>
              <div className="flex-1">
                <div className="flex items-center justify-between gap-2">
                  <span className="font-medium text-slate-900">{n.title}</span>
                  <span className="text-xs text-slate-400 whitespace-nowrap">{timeAgo(n.created_at)}</span>
                </div>
                {n.body && <p className="text-sm text-slate-600 mt-0.5">{n.body}</p>}
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
